import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPeriods = store => store[NAME].periods;
export const getConcepts = store => store[NAME].concepts;
export const getReferences = store => store[NAME].references;
export const getAccumulators = store => store[NAME].accumulators;